<template>
  <div class="image-loader">
    <Loading v-if="isLoading" :background="false" :class="loadingClass"/>
    <img :src="currentSrc"/>
  </div>
</template>

<script>
import Loading from '@/components/v3/loading/Loading.vue'
import Timer from '@/utils/Timer'
import axios from "axios"
import { getModule } from '@/modules/store'
import ConfigStore from '@/modules/config/store/ConfigStore'
import { Base64 } from 'js-base64'

export default {
    components: {
        Loading
    },
    props: {
        src: {
            default: '',
            type: String
        },
        preventCache: {
            type: Boolean,
            default: true
        },
        default: {
            default: '',
            type: String
        },
        whiteSpinner: {
            default: false,
            type: Boolean
        },
        lazyLoad: {
            default: true,
            type: Boolean
        }
    },
    data() {
        return {
            loading: 0,
            intersectionObs: null,
            isVisible: false,
            isLoaded: false,
            currentSrc: this.default,
            loadImageTimer: new Timer()
        }
    },
    mounted() {
        this.intersectionObs = new IntersectionObserver(
            (entries) => {
                console.log('IntersectionObserver', entries)
                if(entries[0].isIntersecting === true) {
                    this.isVisible = true
                    // this.intersectionObs.unobserve(this.$el)
                    this.checkLoadImage()
                } else {
                    this.cancelCheckLoadImage()
                }
            },
            {
                threshold: [0]
            }
        )

        this.intersectionObs.observe(this.$el)
    },
    unmounted() {
        this.intersectionObs.unobserve(this.$el)
        this.loadImageTimer.stop()
    },
    watch: {
        src: {
            handler(newVal, oldVal) {
                // set default for the moment
                if (this.currentSrc !== this.default) this.currentSrc = this.default
                // if new src, preload it
                if (newVal) {
                    this.isLoaded = false
                    this.checkLoadImage()
                }
            },
            immediate: true
        }
    },
    computed: {
        isLoading() {
            return this.loading > 0
        },
        imageClass() {
            return this.loading ? 'loading' : 'loaded'
        },
        loadingClass() {
            return this.whiteSpinner ? 'white-spinner' : ''
        },
        configStore() {
            return getModule(ConfigStore)
        },
    },
    methods: {
        checkLoadImage() {
            if (!this.isVisible) return
            if (this.isLoaded) return
            // this.loadImage()
            this.loading = 1
            this.loadImageTimer.start(1000, this.loadImage, 1)
        },
        cancelCheckLoadImage() {
            if (!this.loadImageTimer.isRunning) return
            this.loading = 0
            this.loadImageTimer.stop()
        },
        loadImage() {
            console.log('loadImage', this.currentSrc)
            this.cancelCheckLoadImage()
            this.loading = 1

            let url = this.$processUrl(this.src)
            if (this.preventCache) {
                url += url.indexOf('?') >= 0 ? '&' : '?'
                url += 'cache=' + Date.now()
                // url += '&Token=' + this.configStore.userToken
            }

            // load image with specific headers (token for identification)
            axios.get(
                url,
                {
                    headers: {
                        Token: this.configStore.userToken
                    },
                    responseType: 'arraybuffer'
                }
            ).then(response => {
                let blob = new Blob([response.data])
                const imageObjectURL = URL.createObjectURL(blob)

                var img = new Image()
                img.addEventListener("load", this.onImageLoaded)
                img.addEventListener("error", this.onImageError)
                img.src = imageObjectURL
                imageObjectURL.revokeObjectURL()
            }).catch(error => {
                console.log('error while retrieving image', error)
                this.onImageError(error)
            })


        },
        onImageLoaded(e) {
            console.log('onImageLoaded', e, this.currentSrc)
            this.loading = 0
            this.isLoaded = true
            this.currentSrc = e.target.src
        },
        onImageError(e) {
            console.log('onImageError', e, this.currentSrc)
            this.loading = 0
            this.isLoaded = true
        }
    }
}
</script>

<style lang="stylus">
.image-loader
  position relative

  img
    transition opacity 0.5s

    &.loading
      visibility hidden
      opacity 0
</style>



// WEBPACK FOOTER //
// src/components/v3/images/ImageLoader.vue